<app-page-bar></app-page-bar>

<app-page>
  <h2>End Customer Duplicates</h2>

  <section>
    <p class="hint">
      End customers sharing a business id that differs only by surrounding
      whitespace. Open a group to review and merge — or keep the rows separate.
    </p>

    <ng-container *ngIf="groups$ | async as groups; else loading">
      <div class="table-container mat-elevation-z8" *ngIf="groups.length > 0; else empty">
        <mat-table [dataSource]="groups">

          <ng-container matColumnDef="business_id">
            <mat-header-cell *matHeaderCellDef>Business ID</mat-header-cell>
            <mat-cell *matCellDef="let group">{{ group.business_id }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="member_count">
            <mat-header-cell *matHeaderCellDef>Members</mat-header-cell>
            <mat-cell *matCellDef="let group">{{ group.members.length }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="names">
            <mat-header-cell *matHeaderCellDef>Names</mat-header-cell>
            <mat-cell *matCellDef="let group">{{ memberNames(group) }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="invoices">
            <mat-header-cell *matHeaderCellDef>Invoices (per member)</mat-header-cell>
            <mat-cell *matCellDef="let group">{{ invoiceCounts(group) }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="flags">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let group">
              <mat-chip-list *ngIf="group.previously_dismissed">
                <mat-chip color="warn" selected>Previously dismissed</mat-chip>
              </mat-chip-list>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let group; columns: columns;" matRipple
                   (click)="openGroup(group)"></mat-row>

        </mat-table>
      </div>

      <ng-template #empty>
        <p class="empty-state">No duplicate groups remaining.</p>
      </ng-template>
    </ng-container>

    <ng-template #loading>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
  </section>
</app-page>
